import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const NotesButton = ({
    isLocked,
    entering,
    isOpenNotesSection,
    openNotesSection,
}) => (
    <OverlayTrigger
        placement='top'
        onEntering={entering}
        overlay={
            <Tooltip
                id='tooltip'
                style={{
                    backgroundColor: 'rgb(0, 35, 58)',
                    color: 'white',
                    marginBottom: '20px',
                }}
            >
                <div
                    style={{
                        backgroundColor: 'rgb(0, 35, 58)',
                        color: 'white',
                    }}
                >
                    Notes
                </div>
            </Tooltip>
        }
    >
        <div
            className={
                isOpenNotesSection
                    ? 'icon_fun outer-col active'
                    : 'icon_fun outer-col'
            }
            style={{
                display: 'inline-block',
            }}
            onClick={isLocked ? null : openNotesSection}
        >
            <span
                className={isOpenNotesSection ? 'active' : null}
                style={
                    isLocked === true
                        ? {
                              cursor: 'not-allowed',
                          }
                        : {}
                }
            >
                <i className='fa-solid fa-sticky-note' />
            </span>
        </div>
    </OverlayTrigger>
);

export default NotesButton;
